import { gql } from "apollo-boost";

export const AmazonIdeaFragment = gql`
    fragment AmazonIdeaFragment on AmazonIdea {
        id
        createdAt
        title
        type
        kpi
        keyword
        keyword2
        keyword3
        keyword4
        keyword5
        description
        isPersonalized
        denyReason
        author {
            id
            firstName
            lastName
        }

        picker {
            id
            firstName
            lastName
        }

        fields {
            type
            label
            ordering
            placeholder
            instructions
            sampleText
            min
            max
            optionsList {
                name
                priceDifference
            }
        }
        status
        asin
        storeTypes {
            id
            label
        }
        productLink
        rejectReason
        mockups {
            id
            name
            key
            size
            mimeType
            url
            thumbnailUrl
        }
        bulletPoint
        stores {
            id
            title
        }
        hexColor
        products {
            id
            asin
            productLink
            status

            store {
                id
                title
            }
        }


        totalStore
    }
`;

export const AmazonIdeaTemplateFragment = gql`
    fragment AmazonIdeaTemplateFragment on AmazonIdeaTemplate {
        id
        createdAt
        title
        author {
            id
            firstName
            lastName
        }

        fields {
            type
            label
            ordering
            placeholder
            instructions
            sampleText
            min
            max
            optionsList {
                name
                priceDifference
            }
        }
    }
`;

export const AmazonIdeaTimelineFragment = gql`
    fragment AmazonIdeaTimelineFragment on AmazonIdeaTimeline {
        id
        createdAt
        content
    }
`;
